import React from "react";

const DuplicateIcon = () => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 0H3.625C3.55625 0 3.5 0.05625 3.5 0.125V1C3.5 1.06875 3.55625 1.125 3.625 1.125H11.375V11.875C11.375 11.9438 11.4313 12 11.5 12H12.375C12.4438 12 12.5 11.9438 12.5 11.875V0.5C12.5 0.223437 12.2766 0 12 0ZM10 2H2C1.72344 2 1.5 2.22344 1.5 2.5V10.7922C1.5 10.925 1.55312 11.0516 1.64687 11.1453L4.35469 13.8531C4.38906 13.8875 4.42813 13.9156 4.47031 13.9391V13.9688H4.53594C4.59062 13.9891 4.64844 14 4.70781 14H10C10.2766 14 10.5 13.7766 10.5 13.5V2.5C10.5 2.22344 10.2766 2 10 2ZM4.46875 12.3781L3.12344 11.0312H4.46875V12.3781ZM9.375 12.875H5.46875V10.6562C5.46875 10.3109 5.18906 10.0312 4.84375 10.0312H2.625V3.125H9.375V12.875Z'
      fill='black'
      fillOpacity='0.7'
    />
  </svg>
);

export default DuplicateIcon;
